package org.lennycodes.hldi.pages.admin

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.components.admin.AdminNavbar

@Composable
fun AdminLayout(
    content: @Composable () -> Unit
) {

    Column(
        modifier = Modifier.fillMaxSize()
    ) {

        // Always visible
        AdminNavbar()


        Box(
            modifier = Modifier
                .fillMaxSize()
                .padding(
                    top = 100.px,
                    left = 32.px,
                    right = 32.px
                )
        ) {

            // Dynamic page content
            content()

        }

    }
}
